export default {
    year: '',
    month: '',
    day: '',
    hour: '',
    minute: '',
    am: 'AM',
    pm: 'PM'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-date-picker/es/locale/en_US.js
// module id = 287
// module chunks = 0